import type {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, type Observable } from 'rxjs';
import { LoadingService } from './loading.service';

@Injectable()
export class LoadingHttpInterceptor implements HttpInterceptor {
  constructor(private loadingService: LoadingService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    this.setLoading(req, true);

    return next.handle(req).pipe(
      finalize(() => {
        this.setLoading(req, false);
      }),
    );
  }

  private setLoading(req, loading): void {
    const isApiRequest = req.url.includes('api/v');
    if (isApiRequest) {
      this.loadingService.loading.set(loading);
    }
  }
}
